<mat-dialog-content>
  <ng-container *ngIf="isMakler">
    <h3>Herzlich Willkommen im NV-Maklercockpit!</h3>
  </ng-container>
  <ng-container *ngIf="!isMakler">
    <h3>Information Funktionalität</h3>
  </ng-container>
  <app-loader *ngIf="loadingRememberMeStatus"></app-loader>
  <div textSmall class="center-text" *ngIf="!loadingRememberMeStatus && !rememberMeActive">
    Mit dieser Option bleiben Sie für längere Zeit auf diesem Gerät angemeldet und müssen sich weniger oft
    anmelden.
    <br/>
    Achtung: Benutzen Sie diese Option nur bei Geräten, die nur von Ihnen benutzt werden und nicht bei
    öffentlichen Geräten, wie z.B. im Internetcafe.
    <app-loader *ngIf="loadingRememberMeStatus"></app-loader>
    <div *ngIf="!loadingRememberMeStatus" class="top-margin-button">
      <pezi-button (click)="rememberMe()" *ngIf="!rememberMeActive" icon="restore" [isOutlined]="true">
        <span>"Angemeldet bleiben" setzen</span>
      </pezi-button>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <pezi-button text="Schließen" [isPlain]="true" icon="close" [alignIconRight]="true" mat-dialog-close></pezi-button>
</mat-dialog-actions>
